import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import Components from "../index"
import SbImageService from "../../helpers/SbImageService"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import linkHandler from "../../helpers/storyblokLinkHandler"
import remarkReactComponents from "../../helpers/remarkReactComponents"

class HeroV2Form extends Component {
  render() {
    const { blok } = this.props

    return (
      <SbEditable content={blok}>
        <div className="hero-v2-form">
          <div className="hero-v2-form__card">
            <div className="hero-v2-form__inner">
              {blok.logo.filename && (
                <a
                  title="Hult"
                  href={linkHandler(blok.logoUrl)}
                  className="hero-v2-form__card-logo hero-v2-form__card-logo--desktop"
                >
                  <img
                    alt="Hult"
                    className="hero-v2-form__card-logo-image hero-v2-form__card-logo-image--desktop"
                    src={blok.logo.filename}
                  />
                </a>
              )}
              {blok.logoMobile.filename && (
                <a
                  title="Hult"
                  href={linkHandler(blok.logoUrl)}
                  className="hero-v2-form__card-logo hero-v2-form__card-logo--mobile"
                >
                  <img
                    alt="Hult"
                    className="hero-v2-form__card-logo-image hero-v2-form__card-logo-image--mobile"
                    src={blok.logoMobile.filename}
                  />
                </a>
              )}
              {blok.eventType && (
                <div className="hero-v2-form__card-event-type">
                  <p>{blok.eventType}</p>
                </div>
              )}
              {blok.title && (
                <h1 className="hero-v2-form__card-title heading--accent">
                  {blok.title}
                </h1>
              )}
              <div className="hero-v2-form__card-desc-image">
                {blok.description && (
                  <div className="hero-v2-form__card-description">
                    {
                      unified()
                        .use(remarkParse)
                        .use(remarkRehype)
                        .use(rehypeReact, {
                          createElement: React.createElement,
                          components: remarkReactComponents,
                          Fragment: React.Fragment
                        })
                        .processSync(blok.description).result
                    }
                  </div>
                )}
              </div>
              {(blok.iconList || blok.eventTimezone) && (
                <div className="hero-v2-form__card-icons">
                  {blok.iconList &&
                    blok.iconList.map((content) =>
                      React.createElement(Components(content.component), {
                        key: content._uid,
                        blok: content,
                      })
                    )}
                  {blok.eventTimezone &&
                    React.createElement(Components("programDetailAttr"), {
                      blok: { icon: "globe", title: blok.eventTimezone },
                    })}
                </div>
              )}
              {blok.brochureImage.filename && (
                <img
                  alt="Hult"
                  className="hero-v2-form__card-image"
                  src={blok.brochureImage.filename}
                />
              )}
            </div>
          </div>
          <div className={`hero-v2-form__form`}>
            {blok.formTitle && (
              <p className="hero-v2-form__form-title">{blok.formTitle}</p>
            )}
            {blok.form &&
              blok.form.map((c) =>
                React.createElement(Components(c.component), {
                  key: c._uid,
                  blok: c,
                  isDark: true,
                })
              )}
          </div>
        </div>
      </SbEditable>
    )
  }
}

HeroV2Form.propTypes = {
  blok: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
}

export default HeroV2Form
